import React from "react";
import { CartItem } from "@swiggy-private/cart-types";

export interface CrossSellM2SuggestionsState {
    suggestions: CartItem[] | null;
    allCrossSellSuggestionsAdded: boolean;
    isFetchingSuggestions: boolean;
    isErrorFetchingSuggestions: boolean;
}

export interface CrossSellM2ContextValue {
    crossSellM2SuggestionsState: CrossSellM2SuggestionsState;
    setCrossSellM2SuggestionsState: React.Dispatch<React.SetStateAction<CrossSellM2SuggestionsState>>;
}

export const INITIAL_CROSS_SELL_M2_SUGGESSTIONS_VALUE: CrossSellM2ContextValue = {
    crossSellM2SuggestionsState: {
        suggestions: null,
        allCrossSellSuggestionsAdded: false,
        isFetchingSuggestions: false,
        isErrorFetchingSuggestions: false,
    },
    setCrossSellM2SuggestionsState: () => void 0,
};

export const CrossSellM2Context = React.createContext<CrossSellM2ContextValue>(
    INITIAL_CROSS_SELL_M2_SUGGESSTIONS_VALUE,
);

if (__DEV__) {
    CrossSellM2Context.displayName = "CrossSellM2Context";
}
